__webpack_require__.p = "https://npm-assets.fiverrcdn.com/assets/@fiverr/vibe_coding_perseus/";